import { type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { addHttpsProtocol } from '#shared/lib/url';

export const PRODUCT_VARIANT_CHECKOUT_DISABLED_HINT =
    'Опубликуйте товар и пополните остатки, чтобы сделать тестовый заказ';

export function getProductVariantCheckoutUrl(
    variant: Pick<OpenApiSchemaProductVariant, 'status' | 'stocks' | 'link_url'> | undefined
): string | undefined {
    if (variant?.status !== 'PUBLISHED' || !variant.link_url) {
        return undefined;
    }

    const hasAvailableStock = variant.stocks.some((stock) => stock.quantity > 0);

    return hasAvailableStock ? addHttpsProtocol(variant.link_url) : undefined;
}
